import React from 'react'
import IconWarning from '../iconComponents/IconWarning'

export default function Warning(props) {

    const warningLine = 
    <svg 
        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF0040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" 
        className="icon gap-right-s"
    >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12" y2="16"></line>
    </svg>
    
    const infoLine = 
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E9AFE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" 
        className="icon info gap-right-s"
    >
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12" y2="8"></line>
    </svg>
    

    return (
        <>
            <div className={`warning-wrap content1 light-black ${props.type} ${props.className ? props.className : ""}`}>  
                {props.type === "info" 
                ? infoLine
                : warningLine
                }
                {/* <IconWarning className="iblock gap-right-m" height="22px" pathClass="red-dark-fill" /> */}
                <div className="iblock warning-text content1 multiline" >{props.children}</div>
            </div>
        </>
    )
}
